var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MiniEventCard } from "../../../components";
import { renderMiniMarketsRegular } from "./RenderMethods";
var Regular = /** @class */ (function (_super) {
    __extends(Regular, _super);
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    function Regular(props) {
        var _this = _super.call(this, props) || this;
        _this.renderMarkets = renderMiniMarketsRegular;
        _this.cardTypeClass = "rj-ev-list__" + _this.componentPrefix + "--regular";
        _this.buttonsHolderClass = "rj-ev-list__" + _this.componentPrefix + "__buttons-holder--regular";
        return _this;
    }
    return Regular;
}(MiniEventCard));
export { Regular };
//# sourceMappingURL=Regular.js.map